import React from "react";
import { Offcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import InventoryFiltersPanel, {
  InventoryCategory,
  InventoryFilterOption,
  InventoryExtraSelect,
} from "./InventoryFiltersPanel";

interface InventoryFiltersDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  selectedOptions: readonly InventoryFilterOption[];
  onSelectedOptionsChange: (options: readonly InventoryFilterOption[]) => void;
  options: InventoryFilterOption[];
  categories: InventoryCategory[];
  activeCategory: string;
  onCategoryChange: (value: string) => void;
  onClear: () => void;
  disabled: boolean;
  extraSelects: InventoryExtraSelect[];
  headerExtras?: React.ReactNode;
  title?: string;
}

const InventoryFiltersDrawer = ({
  isOpen,
  onClose,
  selectedOptions,
  onSelectedOptionsChange,
  options,
  categories,
  activeCategory,
  onCategoryChange,
  onClear,
  disabled,
  extraSelects,
  headerExtras,
  title = "Filtros",
}: InventoryFiltersDrawerProps) => (
  <Offcanvas isOpen={isOpen} toggle={onClose} direction="end">
    <OffcanvasHeader toggle={onClose}>{title}</OffcanvasHeader>
    <OffcanvasBody>
      <InventoryFiltersPanel
        title={title}
        selectedOptions={selectedOptions}
        onSelectedOptionsChange={onSelectedOptionsChange}
        options={options}
        categories={categories}
        activeCategory={activeCategory}
        onCategoryChange={onCategoryChange}
        onClear={onClear}
        disabled={disabled}
        extraSelects={extraSelects}
        headerExtras={headerExtras}
      />
    </OffcanvasBody>
  </Offcanvas>
);

export default InventoryFiltersDrawer;
